import React, { useEffect, useState } from 'react';
import { DatePicker, Input, Modal, Space, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useLanguage } from './LanguageContext';

const { Text } = Typography;

interface Props {
  open: boolean;
  signInAt: string | null;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (correctedSignOutAt: string, note: string) => void;
}

const MissingCheckoutCorrectionModal: React.FC<Props> = ({
  open,
  signInAt,
  loading,
  onCancel,
  onSubmit,
}) => {
  const { t } = useLanguage();
  const [correctedAt, setCorrectedAt] = useState<Dayjs | null>(null);
  const [note, setNote] = useState('');

  useEffect(() => {
    if (open) {
      setCorrectedAt(null);
      setNote('');
    }
  }, [open, signInAt]);

  const signInDay = signInAt ? dayjs(signInAt).format('YYYY-MM-DD') : '';

  return (
    <Modal
      title={t('attendanceCorrectMissingCheckout')}
      open={open}
      confirmLoading={loading}
      okText={t('attendanceSaveCorrection')}
      cancelText={t('cancel')}
      okButtonProps={{ disabled: !correctedAt || note.trim().length < 3 }}
      onCancel={onCancel}
      onOk={() => correctedAt && onSubmit(correctedAt.toISOString(), note.trim())}
      destroyOnClose
    >
      <Space direction="vertical" size={14} style={{ width: '100%' }}>
        {signInAt && (
          <Text type="secondary">
            {t('attendanceOriginalCheckIn')}: {dayjs(signInAt).format('DD/MM/YYYY HH:mm')}
          </Text>
        )}
        <DatePicker
          showTime={{ format: 'HH:mm' }}
          format="DD/MM/YYYY HH:mm"
          value={correctedAt}
          onChange={setCorrectedAt}
          placeholder={t('attendanceCorrectedCheckoutTime')}
          disabledDate={(current) => Boolean(signInDay && current.format('YYYY-MM-DD') !== signInDay)}
          style={{ width: '100%' }}
        />
        <Input.TextArea
          value={note}
          onChange={(event) => setNote(event.target.value)}
          placeholder={t('attendanceCorrectionNotePlaceholder')}
          maxLength={300}
          showCount
          rows={3}
        />
        <Text type="secondary">{t('attendanceCorrectionAuditHelp')}</Text>
      </Space>
    </Modal>
  );
};

export default MissingCheckoutCorrectionModal;
